import { createSelector } from "reselect";
import { RootState } from "../../store/types";
import { StyleChoiceState } from "./reducer";

export const styleChoice = (state: RootState): StyleChoiceState =>
  state.wizardStyleChoice;

const styles = createSelector(styleChoice, state => state.styles);

export const isStylesLoading = createSelector(
  styleChoice,
  state => state.isStylesLoading,
);

export const descriptionValue = createSelector(
  styleChoice,
  state => state.descriptionValue,
);

export const selectedStyle = createSelector(
  styleChoice,
  state => state.selectedStyle,
);

export const displayStyles = createSelector(
  styles,
  selectedStyle,
  (styles, selected) =>
    styles.map(style => ({
      ...style,
      active: selected != null && selected.id === style.id,
    })),
);

export const lastStyleChanged = createSelector(
  styleChoice,
  state => state.lastStyleChanged,
);



// WEBPACK FOOTER //
// ./src/routes/WizardStyleChoice/selectors.ts